import produce from 'immer';

import { featureFlag } from '@@/auto/constants/featureFlags';
import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

function ToyotaCAConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_CA_EXPANSION_ENABLED)
    ? {
        auto: (auto: TConfig['auto']) =>
          produce(auto, (draft) => {
            draft.addOns.alwaysOnOptions!.roadside_assistance.copy.textAlert =
              'Lucky for you this Add On is always on with your Toyota Coverage!';
          }),
        alwaysOnConfig: {
          selfServiceConfig: {
            subHeader:
              'These additional perks are included with every Toyota auto policy.',
          },
          quoteFlowConfig: {
            subHeader:
              'These additional perks are included with every Toyota auto policy.',
          },
        },
        discountsConfig: (discountsConfig: TConfig['discountsConfig']) => {
          return {
            ...discountsConfig,
            removedDiscounts: ['Toyotally Awesome Discount'],
            highlightedDiscountsModalTitle: 'Toyotally Awesome Savings',
            highlightedDiscounts: [
              {
                sidebarTitle: 'Toyotally Awesome Savings',
                title: '',
                description:
                  'You are eligible for a reduced rate because Toyota Insurance Management Solutions is an affinity partner of Toggle, a member of the Farmers Insurance family and the underwriter of Toyota Auto Insurance.',
              },
            ],
          };
        },
      }
    : {};
}
export default ToyotaCAConfig;
